import { DTOBffImportRequestBody, DTOImportJobResponse } from "../../dto";
import { RequestExecutor } from "../../transport/request-executor";

export class DesignSystemBffEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  import(dsId: string, payload: DTOBffImportRequestBody) {
    return this.requestExecutor.json(`/design-systems/${dsId}/bff/import`, DTOImportJobResponse, {
      method: "POST",
      body: payload,
    });
  }
}
